import { render, staticRenderFns } from "./PlayerEditor.vue?vue&type=template&id=06e2fffb"
import script from "./PlayerEditor.vue?vue&type=script&lang=js"
export * from "./PlayerEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports